import { render, staticRenderFns } from "./thematic-type-container.vue?vue&type=template&id=5677fc3b&scoped=true&"
import script from "./thematic-type-container.vue?vue&type=script&lang=js&"
export * from "./thematic-type-container.vue?vue&type=script&lang=js&"
import style0 from "./thematic-type-container.vue?vue&type=style&index=0&id=5677fc3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677fc3b",
  null
  
)

export default component.exports